import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, eur, fmtDate } from "../lib/api";
import { Plus, Receipt } from "lucide-react";
import { Button } from "../components/ui/button";

export default function InvoicesList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/invoices").then(r => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 animate-fade-in" data-testid="invoices-page">
      <header className="flex justify-between items-end flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-orange mb-2">Facturas</div>
          <h1 className="font-display font-bold text-4xl tracking-tight">Facturas</h1>
        </div>
        <div className="flex gap-2">
          <Link to="/app/facturas/nueva">
            <Button data-testid="new-invoice-btn" className="bg-brand-orange hover:bg-brand-orange-hover text-white">
              <Plus className="w-4 h-4 mr-2" /> Nueva factura
            </Button>
          </Link>
          <Link to="/app/presupuestos">
            <Button data-testid="from-estimate-btn" variant="outline" className="border-white/20 bg-transparent text-white hover:bg-white/5">
              Desde presupuesto
            </Button>
          </Link>
        </div>
      </header>

      <div className="rounded-lg border border-white/10 bg-[#0A1128]/40 overflow-hidden">
        {loading ? <div className="p-12 text-center text-white/50">Cargando...</div> :
          items.length === 0 ? (
            <div className="p-16 text-center" data-testid="invoices-empty">
              <Receipt className="w-12 h-12 mx-auto text-white/20 mb-3" strokeWidth={1} />
              <div className="text-white/60">Aún no tienes facturas. Convierte un presupuesto aceptado en factura.</div>
            </div>
          ) : (
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left border-b border-white/10 text-[10px] uppercase tracking-widest text-white/50">
                  <th className="p-4 font-bold">Nº</th>
                  <th className="p-4 font-bold">Cliente</th>
                  <th className="p-4 font-bold">Fecha</th>
                  <th className="p-4 font-bold">Estado</th>
                  <th className="p-4 font-bold text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                {items.map((i) => (
                  <tr key={i.id} onClick={() => navigate(`/app/facturas/${i.id}`)} className="border-b border-white/5 hover:bg-white/5 cursor-pointer transition-colors" data-testid={`invoice-row-${i.id}`}>
                    <td className="p-4 font-mono text-xs">{i.number}</td>
                    <td className="p-4">{i.client_snapshot?.name || "—"}</td>
                    <td className="p-4 text-white/60">{fmtDate(i.issue_date || i.created_at)}</td>
                    <td className="p-4"><span className={`px-2 py-1 rounded text-[10px] uppercase font-bold ${i.paid ? "bg-emerald-500/15 text-emerald-400" : "bg-brand-orange/15 text-brand-orange"}`}>{i.paid ? "cobrado" : "pendiente"}</span></td>
                    <td className="p-4 text-right font-semibold">{eur(i.total || 0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
      </div>
    </div>
  );
}
